import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, FileText, ArrowRight, MapPin } from 'lucide-react';
import { AnnonceListItem } from '../data/annonces';
import './AnnonceCard.css';

interface Props {
  annonce: AnnonceListItem;
  index: number;
}

const getCategorieClass = (type?: string): string => {
  if (!type) return 'badge-creation';
  const t = type.toLowerCase();
  if (t.includes('constitution') || t.includes('création')) return 'badge-creation';
  if (t.includes('modification') || t.includes('augmentation') || t.includes('cession')) return 'badge-modification';
  if (t.includes('dissolution')) return 'badge-dissolution';
  if (t.includes('liquidation') || t.includes('cloture')) return 'badge-liquidation';
  return 'badge-creation';
};

const formatDate = (dateStr: string): string => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return dateStr;
  }
};

const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength).trimEnd() + '...';
};

const AnnonceCard: React.FC<Props> = ({ annonce, index }) => {
  const typeLabel = annonce.type_annonce || 'Annonce';
  const badgeClass = getCategorieClass(annonce.type_annonce);
  const detailLink = `/annonce/${annonce.id}`;

  return (
    <div className="annonce-card">
      <div className="card-content">
        <div className="card-top">
          <span className={`card-badge ${badgeClass}`}>
            {typeLabel}
          </span>
          <span className="card-date">
            <Calendar size={13} />
            {formatDate(annonce.date_publication)}
          </span>
        </div>

        <h3 className="card-title">{annonce.nom_societe}</h3>

        <div className="card-company">
          <FileText size={14} />
          <span className="company-name">{annonce.nom_societe}</span>
          {annonce.forme_juridique && (
            <span className="company-forme">{annonce.forme_juridique}</span>
          )}
        </div>

        {annonce.siege_social && (
          <p className="card-excerpt">
            <MapPin size={13} style={{ display: 'inline', verticalAlign: 'middle', marginRight: 4 }} />
            {truncateText(annonce.siege_social, 80)}
          </p>
        )}

        {annonce.contenu_complet && (
          <p className="card-excerpt-text">
            {truncateText(annonce.contenu_complet, 150)}
          </p>
        )}

        <div className="card-footer">
          <div className="card-meta">
            <span className="meta-item">
              <FileText size={13} />
              {annonce.version === 'v1_fratmat' ? 'Fraternité Matin' : 'Journal Officiel'}
            </span>
          </div>
          <Link to={detailLink} className="card-link">
            Voir détails <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AnnonceCard;
